<template>
  <div id="app">
    <AppHeader/>
    <main>
      <slot></slot>
    </main>
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
  .main-container.absolute{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
  }
  #app{
    @media screen and (max-width: 1500px) {
      .header{
        .container{
          margin: 0 70px 0 50px;
          .logo img{
            height: 30px;
            margin-top: 4px;
          }
          nav .nav-box{
            .nav-item{
              &>a{
                padding: 0 21px;
              }
            }
          }
        }
      }
    }
    @media screen and (max-width: 1366px) {
      .header{
        .container{
          font-size: 16px;
          margin: 0 40px 0 30px;
          .logo img{
            height: 26px;
            margin-top: 6px;
          }
        }
      }
    }
    @media screen and (max-width: 1280px) {
      .header{
        .container{
          margin: 0 20px 0 15px;
          font-size: 15px;
          .logo img{
            height: 24px;
            margin-top: 7px;
          }
          nav .nav-box{
            .nav-item{
              &>a{
                padding: 0 15px;
              }
            }
          }
        }
      }
    }
    @media screen and (max-width: 1100px) {
      .header{
        .container{
          margin: 0 15px;
          font-size: 14px;
          .logo img{
            height: 24px;
            margin-top: 7px;
          }
        }
      }
    }
    @media screen and (max-width: 1000px) {
      .header{
        .container{
          margin: 0 14px;
          font-size: 13px;
          .logo img{
            height: 22px;
            margin-top: 9px;
          }
          nav .nav-box{
            .nav-item{
              &>a{
                padding: 0 10px;
              }
            }
          }
        }
      }
    }
    @media screen and (max-width: 930px) {
      .header{
        .container{
          font-size: 12px;
          nav .nav-box{
            .nav-item{
              &>a{
                padding: 0 10px;
              }
            }
          }
        }
      }
    }  
  }
</style>